import { useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
//
import { Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { LuListMinus } from "react-icons/lu";
import { PiHandCoinsFill } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { PlaceholderButton } from "../../Components/Placeholders.jsx";
import Table from "../../Components/Table/Table.js";
import ToolTip from "../../Components/ToolTip.js";
import ThemeSpinner from "../../Components/general/ThemeSpinner.jsx";
import { useGetAllGamesQuery, useGetAllSubGamesByGameSlugQuery } from "../../store/apis/gameApi.js";
import { GAME_ENUM } from "../../utils/app-constants.js";
import { IoIosStats } from "react-icons/io";
import { FaUserShield } from "react-icons/fa6";
import { BackButton, SubTitle } from "../../Components/index.js";

const SubGameScreen = ({ setPage }) => {
    const GAME_SLUG = GAME_ENUM.SLOT_MACHINE
    const navigate = useNavigate()
    const {
        control,
        formState: { errors },
    } = useForm({ mode: "onChange" });

    const [indicationMessage, setIndicationMessage] = useState("loading...");

    const [apiData, setApiData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);

    const [searchQuery, setSearchQuery] = useState("");

    const { data, isSuccess, isLoading, refetch } =
        useGetAllSubGamesByGameSlugQuery({ slug: GAME_SLUG }, { refetchOnMountOrArgChange: true });


    useEffect(() => {
        if (isSuccess && data?.data) {
            setApiData(data.data); // Save raw API data
            setFilteredData(data.data); // Initially same as raw

            if (data.data.length === 0) {
                setIndicationMessage("Data not available");
            }
        }
    }, [data, isSuccess]);

    useEffect(() => {
        const lowerQuery = searchQuery.toLowerCase();
        const results = apiData.filter((item) =>
            item?.theme?.toLowerCase().includes(lowerQuery)
        );
        if (results.length === 0) {
            setIndicationMessage("Data not found.")
        }
        setFilteredData(results);
    }, [searchQuery, apiData]);


    function indication() {
        return indicationMessage;
    }

    const columns = [
        {
            dataField: "theme",
            text: "Theme",
            sort: true,
            headerStyle: {
                // width: "150px",
            },
        },

        {
            dataField: "coins_won",
            text: "Coins Won",
            sort: true,
            headerAlign: "center",
            align: "center",
            headerStyle: {
                width: "150px",
            },
            formatter: (cellContent, row) => {
                return (
                    <p>{row.coins_won}</p>
                );
            },
        },
        {
            dataField: "coins_loss",
            text: "Coins Loss",
            sort: true,
            headerAlign: "center",
            align: "center",
            headerStyle: {
                width: "150px",
            },
            formatter: (cellContent, row) => {
                return (
                    <p>{row.coins_loss}</p>
                );
            },
        },
        {
            dataField: "tickets_won",
            text: "Tickets Won",
            sort: true,
            headerAlign: "center",
            align: "center",
            headerStyle: {
                width: "150px",
            },
            formatter: (cellContent, row) => {
                return (
                    <p>{row.tickets_won}</p>
                );
            },
        },
        {
            dataField: "tickets_loss",
            text: "Tickets Loss",
            sort: true,
            headerAlign: "center",
            align: "center",
            headerStyle: {
                width: "150px",
            },
            formatter: (cellContent, row) => {
                return (
                    <p>{row.tickets_loss}</p>
                );
            },
        },
        {
            dataField: "actions",
            text: "Actions",
            headerAlign: "center",
            align: "center",
            headerStyle: {
                width: "200px",
            },
            formatter: (cellContent, row) => {
                // console.log(row)
                if (row.slug) {
                    return (
                        <div className="d-flex justify-content-center align-items-center ">
                            <ToolTip placement={"top"} content={"View Stats"}>
                                <div
                                    className="d-flex justify-content-center align-items-center bg-red-hover rounded-3 p-2 mx-2"
                                    role="button"
                                    onClick={() => navigate(`/admin/game/${GAME_SLUG}/${row.slug}/stats`)}
                                >
                                    <span className={`d-flex align-items-center pe-1`}>
                                        <IoIosStats size={22} />
                                    </span>
                                </div>
                            </ToolTip>
                            <ToolTip placement={"top"} content={"View User Stats"}>
                                <div
                                    className="d-flex justify-content-center align-items-center bg-red-hover rounded-3 p-2 mx-2"
                                    role="button"
                                    onClick={() => navigate(`/admin/game/${GAME_SLUG}/${row.slug}/user/stats`)}
                                >
                                    <span className={`d-flex align-items-center pe-1`}>
                                        <FaUserShield size={22} />
                                    </span>
                                </div>
                            </ToolTip>
                        </div>
                    );
                }
            },
        },
    ];

    return (
        <div className="MainContainer">
            <div className="headerContainer">
                <Row className="w-100 align-items-center">
                    <Col md={6}>
                        <div className="d-flex flex-row align-items-center gap-3 text-white">
                            <BackButton isRelative={true} />
                            <SubTitle text={GAME_SLUG.replace('-', ' ') + ' themes'} classes="text-capitalize" />
                        </div>
                    </Col>

                    <Col md={6}>
                        {
                            isLoading ?
                                <PlaceholderButton />
                                :
                                <Controller
                                    name="search"
                                    control={control}
                                    render={({ field }) => (
                                        <>
                                            <Form.Control
                                                {...field}
                                                placeholder="Search by name"
                                                type="text"
                                                value={searchQuery}
                                                onChange={(e) => setSearchQuery(e.target.value)}
                                            />
                                        </>
                                    )}
                                />}
                    </Col>
                </Row>
            </div>

            <div className="mainTable">
                {isLoading ? (
                    <ThemeSpinner />
                ) : (
                    <Table
                        // classes={`${dataFetched && isFetching ? "blur-table" : ""}`}
                        data={filteredData || []}
                        columns={columns}
                        indication={indication}
                        refetch={() => { }}
                    />
                )}
            </div>
        </div>
    );
};

export default SubGameScreen;
